import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class AllPostingsStateModel extends PaginatedSubentityStateModel {
    static identifier = 'AllPostingsStateModel';

    language: string;
    type: number;

    constructor() {
        super(AllPostingsStateModel.identifier);

        this.language = null;
    }
}
